import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';

import {SimType, StepCustomerEntityData, StepCustomerValue} from 'models';
import { FunnelInfo } from 'models';
import { DynamicEntityKey } from 'models';
import { StepId } from 'models';
import {SimTypeEnum} from '../../../../../app-shared/models/steps/step-sim.interface';
import { EntityStoreFacadeService } from '../../../../facades/entity-store-facade/entity-store-facade.service';
import {SimTypeTypes} from '../../../../modules/process/constants/sim.constants';
import { NavigationActions, NavigationHelpers } from '../../../navigation-feature-store';
import * as FlowActions from '../../actions/flow.actions';

@Injectable()
export class StepCustomerEffects {

  private filterByStep = NavigationHelpers.filterByStepFactory(this.entityStoreFacadeService.store$);


  goNext$ = createEffect(() => this.actions$.pipe(
    ofType(NavigationActions.goNext),
    this.filterByStep(StepId.Customer),
    withLatestFrom(
      this.entityStoreFacadeService.step.customerValue$,
      this.entityStoreFacadeService.entity.simType$
    ),
    map(([ , customerStepData, simType ]: [ any, StepCustomerValue, SimType ]) => {
      const { customerIdentity, generalConsents/*, marketingConsents*/ } = customerStepData;
      const browserWindow = (window as any) || {};
      const customerDataPayload: StepCustomerEntityData = {
        [DynamicEntityKey.CustomerIdentity]: {
          ...customerIdentity,
          firstName: (customerIdentity.firstName || '')
            .replace(/’/gi, '\'')
            .replace(/`/gi, '\'')
            .trim(),
          lastName: (customerIdentity.lastName || '')
            .replace(/’/gi, '\'')
            .replace(/`/gi, '\'')
            .trim(),
          taxCode: (customerIdentity.taxCode || '').toUpperCase(),
          customerGUID: browserWindow._elqQ_GUID ||
            (browserWindow.elqGetGuidCookieValue && browserWindow.elqGetGuidCookieValue())
            || ''
        },
        // [DynamicEntityKey.MarketingConsents]: marketingConsents
      };
      const simTypeValue = (simType as any).value || simType || '';
      if (simTypeValue.type !== SimTypeEnum.IdleSim) {
        customerDataPayload[DynamicEntityKey.GeneralConsents] = generalConsents;
      }
      return FlowActions.postStepData( { data: customerDataPayload, stepId: StepId.Customer });
    })
  ));


  goPrevious$ = createEffect(() => this.actions$.pipe(
    ofType(NavigationActions.goPrevious),
    this.filterByStep(StepId.Customer),
    withLatestFrom(
      this.entityStoreFacadeService.entity.funnelInfo$ // ,
      // this.entityStoreFacadeService.entity.availableSimTypes$,
    ),
    map(([ , funnelInfo/*, availableSimTypes*/ ]: [ any, FunnelInfo/*, AvailableSimTypes */ ]) => {
      const { returnUrl } = funnelInfo;
      return NavigationActions.navigateTo({ commands: [ returnUrl ], extras: null, external: true });
      /*if (availableSimTypes.types.length === 1 && availableSimTypes.types[0] === SimTypeEnum.Standard) {
        const { returnUrl } = FunnelInfo;
        return NavigationActions.navigateTo({ commands: [ returnUrl ], extras: null, external: true });
      }*/
    })
  ));

  restoreStepFromStorage$ = createEffect(() => this.actions$.pipe(
    ofType(NavigationActions.restoreStepFromStorage),
    this.filterByStep(StepId.Customer),
    map(({ storage }: any) => {
      this.entityStoreFacadeService.entity.storeEntityValue(DynamicEntityKey.CustomerIdentity, storage.customerIdentity);
      this.entityStoreFacadeService.entity.storeEntityValue(DynamicEntityKey.GeneralConsents, storage.generalConsents);
      this.entityStoreFacadeService.entity.storeEntityValue(DynamicEntityKey.MarketingConsents, storage.marketingConsents);
      this.entityStoreFacadeService.entity.storeEntityValue(DynamicEntityKey.SimType, storage.simType);
      return null;
    }),
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private entityStoreFacadeService: EntityStoreFacadeService
  ) {}
}
